import { FacebookPageDto } from 'gleblu-socket-api';

import FacebookPage from '../interfaces/FacebookPage';

export function fromDto(facebookPageDto: FacebookPageDto): FacebookPage | null {
  if (!facebookPageDto) return null;

  const { pageId, pageToken, pageName } = facebookPageDto;

  return {
    pageId,
    pageToken,
    pageName,
  };
}

export function toDto(facebookPage: FacebookPage, placeUuid: string): FacebookPageDto {
  const { pageId, pageToken, pageName } = facebookPage;

  return {
    placeUuid,
    pageId,
    pageToken,
    pageName,
  };
}
